import React from "react";

import { Box, Flex, Grid, GridItem } from "@chakra-ui/react";

import {
	ADIF_RED,
	EstadoComunicacionIndicator,
	isIssuerPending,
	isRecipientPending,
} from "common/components/EstadoComunicacionIndicator";
import IndiceIndicator from "common/components/IndiceIndicator";
import { PortfolioInfoLine } from "common/components/PortfolioInfoLine";
import { ActivoCompletoOutput } from "components/Portfolio/types/activos";
import { useAppSelector } from "store/store";

import { BotonComunicaciones } from "./Comunicaciones";
interface IProps {
	asset: ActivoCompletoOutput;
	onOpenComunicaciones: (asset: ActivoCompletoOutput) => void;
}

const timestampFormatter = Intl.DateTimeFormat("es-ES", {
	day: "2-digit",
	month: "2-digit",
	year: "numeric",
	hour: "2-digit",
	minute: "2-digit",
});

export const ComunicacionesRow: React.FC<IProps> = (props) => {
	const { asset } = props;
	const userEmail = useAppSelector((state) => state.user.userEmail)
		.trim()
		.toLowerCase();
	const recipientPending = !!userEmail && isRecipientPending(asset, userEmail);
	const issuerPending = !!userEmail && isIssuerPending(asset, userEmail);
	const pending = recipientPending || issuerPending;

	return (
		<Box
			p=".5rem 0"
			rounded="md"
			bgColor={pending ? "red.50" : "white"}
			mt=".5rem"
			pl="1rem"
			pr="1rem"
			h="2.5rem"
			borderLeft="4px solid"
			borderLeftColor={pending ? ADIF_RED : "transparent"}
		>
			<Flex height="100%" alignItems="center">
				<Grid templateColumns="repeat(22, 1fr)" w="100%" color="gray.800" alignItems="center">
					<GridItem colSpan={1} pl=".5rem">
						<EstadoComunicacionIndicator estado={asset.estado_comunicacion} />
					</GridItem>
					<GridItem data-testid="assetName" colSpan={5}>
						<PortfolioInfoLine
							value={asset.nombre}
							href={`/activo/${asset.id}/portada/${asset.ite_id}`}
							color={pending ? ADIF_RED : undefined}
							fontWeight={pending ? "bold" : undefined}
						/>
					</GridItem>
					<GridItem colSpan={4}>
						<PortfolioInfoLine value={asset.ambito} />
					</GridItem>
					<GridItem colSpan={2}>
						{asset.nec_indice && <IndiceIndicator indice={asset.nec_indice.toLocaleString()} />}
					</GridItem>
					<GridItem colSpan={3}>
						<PortfolioInfoLine
							value={asset.issuer}
							color={issuerPending ? ADIF_RED : undefined}
							fontWeight={issuerPending ? "bold" : undefined}
						/>
					</GridItem>
					<GridItem colSpan={3}>
						<PortfolioInfoLine
							value={asset.recipients?.join(", ")}
							color={recipientPending ? ADIF_RED : undefined}
							fontWeight={recipientPending ? "bold" : undefined}
						/>
					</GridItem>
					<GridItem colSpan={2}>
						<PortfolioInfoLine
							value={
								asset.comunicacion_ultima_actualizacion
									? timestampFormatter.format(new Date(asset.comunicacion_ultima_actualizacion))
									: undefined
							}
						/>
					</GridItem>
					<GridItem colSpan={2}>
						<BotonComunicaciones onOpenComunicaciones={() => props.onOpenComunicaciones(asset)} />
					</GridItem>
				</Grid>
			</Flex>
		</Box>
	);
};
